const log = {
    invalid_type: 'نوع السجل غير صالح.',
};
export default Object.freeze(log);
